import { defineAction } from '~/prix'
import communityDeleteAction from './communityDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const communityDeleteDefinition = defineAction({
  ...communityDeleteAction,

  input: z.object({
    id: z.string(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default communityDeleteDefinition
